"use client";
import {
  useSelectStore
} from "../__chunks/SVBVYDIK.js";
import "../__chunks/UNDSQXBK.js";
import {
  SelectContextProvider
} from "../__chunks/TKSBJDO3.js";
import "../__chunks/7GBW5FLS.js";
import "../__chunks/Y6GYTNQ2.js";
import "../__chunks/3D6OCOHF.js";
import "../__chunks/MADQZZRL.js";
import "../__chunks/TE637IA7.js";
import "../__chunks/XXVAHUAO.js";
import "../__chunks/J55AVALY.js";
import "../__chunks/5M6RSQEC.js";
import "../__chunks/XWCFCD3Q.js";
import "../__chunks/I62TROYO.js";
import "../__chunks/HZJ2XALY.js";
import "../__chunks/EKQEJRUF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/select/select-provider.tsx
import { jsx } from "react/jsx-runtime";
function SelectProvider(props = {}) {
  const store = useSelectStore(props);
  return /* @__PURE__ */ jsx(SelectContextProvider, { value: store, children: props.children });
}
export {
  SelectProvider
};
